import React, { Component } from 'react'
import { buildTitle } from '../../components/UserProfile'
import { Row, Col } from 'react-flexbox-grid'
import CollapsibleSection from '../../controls/CollapsibleSection'
import PasswordField from '../../controls/PasswordField'
import InputField from '../../controls/InputField'
import RBButton from '../../controls/RBButton'
import { localize, getLocale } from '../../util/Localizer'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { fetchMemberSummary } from '../../redux/actions/memberSummaryActions'
import { updateBanking } from '../../redux/actions/userProfileActions'
import { Colors } from '../../theme'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Config from '../../Config'
// import DialogActions from '@material-ui/core/DialogActions'

class Banking extends Component {
  constructor (props) {
    super(props)
    this.checkEnter = this.checkEnter.bind(this)
    this.enterSave = this.enterSave.bind(this)
    this.validate = this.validate.bind(this)
    this.disableButton = this.disableButton.bind(this)
    this.saveInfo = this.saveInfo.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.loadBankingInformation = this.loadBankingInformation.bind(this)
    this.cancel = this.cancel.bind(this)
    this.handleNumInput = this.handleNumInput.bind(this)
    this.state = {
      bankingErrors: {
        accountNumber: '',
        bankNumber: '',
        bankTransitNumber: '',
        password: ''
      },
      accountNumber: '',
      bankNumber: '',
      bankTransitNumber: '',
      password: '',
      open: false, // this is used for the dialog
      bankingUpdateState: {
        error: undefined,
        savingInProgress: false,
        successfullySaved: false
      }
    }
  }

  componentDidMount () {
    if (this.props.memberSummary.bankingInformation) {
      this.loadBankingInformation(this.props.memberSummary.bankingInformation)
    }
  }

  loadBankingInformation (bankingInfo) {
    let banking = bankingInfo
    if (this.state.password === '') {
      let init = {
        accountNumber: banking.accountNumber,
        bankNumber: banking.bankNumber,
        bankTransitNumber: banking.bankTransitNumber
      }
      this.setState({ ...init })
    }
  }

  handleOpen () {
    this.setState({ open: true })
  }

  handleClose () {
    this.setState({ open: false, password: '' },
      () => {
        this.props.fetchMemberSummary()
      })
  }

  handleNumInput (e, val) {
    let stateObj = e.target.id

    // remove non numeric chars
    let num = val.replace(/\D/g, '')

    // make sure there is a max length
    if (stateObj === 'bankTransitNumber' && val.length > 5) {
      num = num.substring(0, 5)
    } else if (stateObj === 'bankNumber' && val.length > 3) {
      num = num.substring(0, 3)
    } else if (stateObj === 'accountNumber' && val.length >= 16) {
      num = num.substring(0, 16)
    }
    this.validate()
    // set the state
    this.setState({ [stateObj]: num })
  }

  cancel () {
    if (this.props.isProfile) {
      window.location.reload()
      this.handleClose()
    } else {
      this.handleClose()
    }
  }

  saveInfo () {
    if (this.validate()) {
      let bankObj = {
        'CurrentPassword': this.state.password,
        'TransitNumber': this.state.bankTransitNumber,
        'InstitutionNumber': this.state.bankNumber,
        'AccountNumber': this.state.accountNumber,
        'ClientIP': ''
      }

      // set the state to show we are saving banking
      this.setState({ bankingUpdateState: { error: undefined, savingInProgress: true, successfullySaved: false } })
      this.props.updateBanking(bankObj,
        (data) => {
          if (this.props.saveComplete) {
            this.props.saveComplete(data)
          }
          this.handleClose()
          if (this.props.isProfile) {
            this.setState({ password: '', bankingUpdateState: { error: undefined, savingInProgress: false, successfullySaved: true } })
          }
        },
        (data) => {
          if (this.props.errorOnSave) {
            this.props.errorOnSave(data)
          }
          this.setState({ bankingUpdateState: { error: data.message, savingInProgress: false, successfullySaved: false } })
        })
    }
  }

  checkEnter (event) {
    const code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      this.setState({ enterSave: true }, this.validate)
    }
  }

  validate () {
    let isValid = true
    const { bankingErrors } = { ...this.state }
    const banking = this.state
    // check for password
    if (banking.password === '') {
      bankingErrors.password = localize('pages.userProfile.banking.passwordError')
      isValid = false
    } else {
      bankingErrors.password = ''
    }

    // check for transit number
    if (banking.bankTransitNumber === '') {
      bankingErrors.bankTransitNumber = localize('pages.userProfile.banking.transitNumberError')
      isValid = false
    } else if (banking.bankTransitNumber.length !== 5) {
      bankingErrors.bankTransitNumber = localize('pages.userProfile.banking.transitNumberErrorSpecific')
      isValid = false
    } else {
      bankingErrors.bankTransitNumber = ''
    }

    // check for institution number
    if (banking.bankNumber === '') {
      bankingErrors.bankNumber = localize('pages.userProfile.banking.institutionNumberError')
      isValid = false
    } else if (banking.bankNumber.length !== 3) {
      bankingErrors.bankNumber = localize('pages.userProfile.banking.institutionNumberErrorSpecific')
      isValid = false
    } else {
      bankingErrors.bankNumber = ''
    }

    // check for account
    if (banking.accountNumber === '') {
      bankingErrors.accountNumber = localize('pages.userProfile.banking.accountNumberError')
      isValid = false
    } else if (banking.accountNumber.length < 7 || banking.accountNumber.length > 16) {
      bankingErrors.accountNumber = localize('pages.userProfile.banking.accountNumberErrorSpecific')
      isValid = false
    } else {
      bankingErrors.accountNumber = ''
    }

    this.setState({ bankingErrors })
    return isValid
  }

  enterSave () {
    if (this.state.enterSave) {
      this.setState({ enterSave: false })
      if (!this.disableButton()) {
        this.saveInfo()
      }
    }
  }

  disableButton () {
    const s = this.state
    return !(s.password)
  }

  renderForm () {
    const { viewOnlyBanking } = Config
    const logo = getLocale() === 'en' ? './img/check_example.png' : './img/check_example_fr.png'
    if (this.state) {
      const values = this.state
      let bankingErrors = this.state.bankingErrors
      // min width added for ie's sake
      return (
        <div style={{ minWidth: 565 }}>
          <Row>
            <Col xs={11} md={6} >
              <br />
              <img src={logo} alt='Check example' />
              {this.props.isProfile
                ? <PasswordField
                  id='bankingPassword'
                  type='password'
                  fullWidth
                  floatingLabelText={localize('pages.userProfile.currentPassword')}
                  onChange={(e, password) => this.setState({ password })}
                  onKeyPress={this.checkEnter}
                  value={values.password}
                  onBlur={this.validate}
                  errorText={bankingErrors.password}
                  readOnly={viewOnlyBanking}
                /> : null }
              <InputField
                id='bankTransitNumber'
                fullWidth
                floatingLabelText={localize('pages.SubmitAClaim.CertificationAndAuthorization.TransitNumber')}
                value={values.bankTransitNumber}
                onChange={(e, bankTransitNumber) => this.handleNumInput(e, bankTransitNumber)}
                onKeyPress={this.checkEnter}
                onBlur={this.validate}
                errorText={bankingErrors.bankTransitNumber}
                readOnly={viewOnlyBanking}
              />
              <InputField
                id='bankNumber'
                fullWidth
                floatingLabelText={localize('pages.SubmitAClaim.CertificationAndAuthorization.InstitutionNumber')}
                value={values.bankNumber}
                onChange={(e, bankNumber) => this.handleNumInput(e, bankNumber)}
                onKeyPress={this.checkEnter}
                onBlur={this.validate}
                errorText={bankingErrors.bankNumber}
                readOnly={viewOnlyBanking}
              />
              <InputField
                id='accountNumber'
                fullWidth
                floatingLabelText={localize('pages.SubmitAClaim.CertificationAndAuthorization.AccountNumber')}
                value={values.accountNumber}
                onChange={(e, accountNumber) => this.handleNumInput(e, accountNumber)}
                onKeyPress={this.checkEnter}
                onBlur={this.validate}
                errorText={bankingErrors.accountNumber}
                readOnly={viewOnlyBanking}
              />
              {!this.props.isProfile
                ? <PasswordField
                  id='bankingPassword'
                  type='password'
                  fullWidth
                  floatingLabelText={localize('pages.userProfile.currentPassword')}
                  onChange={(e, password) => this.setState({ password })}
                  onKeyPress={this.checkEnter}
                  value={values.password}
                  onBlur={this.validate}
                  errorText={bankingErrors.password}
                  readOnly={viewOnlyBanking}
                /> : null }
            </Col>
          </Row>
          {!this.props.isProfile && !this.state.bankingUpdateState.savingInProgress && this.state.bankingUpdateState.error
            ? <Row center='xs' middle='xs'>
              <Col xs={12}>
                <p style={{ color: Colors.Palette.errorColor, textAlign: 'center' }}>{this.state.bankingUpdateState.error}</p>
              </Col>
            </Row>
            : null}
          {!this.props.isProfile && !this.state.bankingUpdateState.savingInProgress && this.state.bankingUpdateState.successfullySaved
            ? <Row center='xs' middle='xs'>
              <Col xs={12}>
                <p style={{ color: Colors.Palette.successColor, textAlign: 'center' }}>{localize('pages.userProfile.banking.updated')}</p>
              </Col>
            </Row>
            : null}
          <div className='buttonContainer fltRight'>
            <RBButton
              variant='outlined'
              id='cancelBtn'
              label={localize('common.cancel')}
              onClick={this.cancel} />
            <RBButton
              variant='contained'
              id='saveBtn'
              label={localize('common.saveUpdates')}
              primary
              onClick={this.saveInfo}
              disabled={this.disableButton()}
              loading={this.state.bankingUpdateState.savingInProgress}
            />
          </div>
        </div>
      )
    }
  }
  render () {
    if (this.props.isProfile) {
      return (
        <div>
          <CollapsibleSection
            id='banking'
            showMuiBorder={false}
            isProfile={this.props.isProfile}
            heading={buildTitle('pages.userProfile.banking.title', 'pages.userProfile.banking.subtitle')}
            expanded={this.props.expanded}
            onExpanded={(key, expanded) => this.props.onExpanded(expanded)}>
            {this.props.isLoading ? <div></div> : this.renderForm()}
          </CollapsibleSection>
          <hr />
        </div>
      )
    } else {
      return (
      // update this to be a material ui dialog popup
      // http://www.material-ui.com/#/components/dialog

        <div>
          <RBButton
            variant='outlined'
            id='dialogBtn'
            label={localize('pages.SubmitAClaim.CertificationAndAuthorization.UpdateBankingInformationButton')}
            onClick={this.handleOpen} />
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}

          >
            <DialogTitle>{localize('pages.userProfile.banking.title')}</DialogTitle>
            <DialogContent>{this.renderForm()}</DialogContent>
          </Dialog>
        </div>
      )
    }
  }
}
function mapStateToProps (state, ownProps) {
  return Object.assign({}, ownProps, {
    memberSummary: state.memberSummaryReducer.memberSummary,
    isLoading: state.memberSummaryReducer.isLoading,
    loading: state.UserProfileReducers.loading || false,
    success: state.UserProfileReducers.bankingSuccess || false,
    error: state.UserProfileReducers.error || false
  })
}
const ConnectedBanking = connect(mapStateToProps, { fetchMemberSummary, updateBanking })(injectIntl(Banking))
export default ConnectedBanking



// WEBPACK FOOTER //
// ./src/widgets/userProfile/Banking.js